import axios from 'axios'

const validateEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const sendSubscription = async ({ email, setState }) => {
  if (!email) return setState({ errorMessage: 'Email is required' })
  if (!validateEmail(email))
    return setState({ errorMessage: 'Email is not valid' })
  setState({ isSent: true })

  try {
    await axios.post('/api/v1/newsletter', {
      email: email.trim(),
    })
    setState({ email: '', errorMessage: '' })
  } catch (error) {
    setState({ isSent: false, errorMessage: '' })
    setTimeout(
      // call after ui update
      () => alert('Sending failed'),
      1,
    )
  }
}
